// libs
import { useState } from "react";

// styles
import classes from "./styles.module.css";

export default function CustomInput({
  value,
  setValue,
  placeholder = "",
  defaultPlaceholder = "",
  className = "",
}) {
  const [isActiveInput, setIsActiveInput] = useState(Boolean(value));

  const onFocus = () => {
    setIsActiveInput(true);
  };

  const onBlur = () => {
    if (value === "") {
      setIsActiveInput(false);
    }
  };

  const onSetValue = (e) => {
    const value = e.target.value;
    setValue(value);
  };

  return (
    <div className={classes.root}>
      {placeholder && <p className={`${classes.placeholder} ${isActiveInput && classes.placeholderActive}`}>{placeholder}</p>}

      <input
        className={`${classes.input} ${className}`}
        value={value}
        placeholder={defaultPlaceholder}
        onChange={onSetValue}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </div>
  );
}
